import { P } from "@cd2/text/build/es6"
import { format } from "date-fns"
import React from "react"
import { Link } from "react-router-dom"
import { createTable } from "../../Components/_createTable"
import { buildRoute, eRoutes } from "../../routes"
import { rmaReturnReasonMessage, rmaStatusMessages, rmaStatusSimplified } from "./RmasIndexPage"
import { HoverCustomerLoader } from "../../hoverLoaders/HoverCustomerLoader"

export const rmasTable = createTable({
  model: "rmas",
  columns: [
    {
      key: "identifier",
      sort: "identifier",
      attributes: ["identifier"],
      render: {
        heading: "Identifier",
        render(row: any): React.ReactNode {
          return (
            <Link to={buildRoute(eRoutes["/customer-support/rma/:id"], { id: row.id })}>
              RMA{row.identifier ?? "-"}
            </Link>
          )
        },
      },
    },
    {
      key: "creditNumber",
      sort: "creditNumber",
      attributes: ["creditNumber"],
      render: {
        heading: "Credit Note",
        render(row: any): React.ReactNode {
          return row.creditNumber ?? "-"
        },
      },
    },
    {
      key: "status",
      sort: "status",
      attributes: ["status"],
      render: {
        heading: "Status",
        render(row: any): React.ReactNode {
          return rmaStatusSimplified[row.status as keyof typeof rmaStatusSimplified]
        },
      },
    },
    {
      key: "customer",
      attributes: ["customer"],
      render: {
        heading: "Customer",
        render(row: any): React.ReactNode {
          return row.customer ? <HoverCustomerLoader id={row.customer.id} /> : null
        },
      },
    },
    {
      key: "order",
      attributes: [
        { as: "orderIdentifier", value: { path: ["order", "identifier"] } },
        "salesNumber",
      ],
      render: {
        heading: "Order Number",
        render(row: any): React.ReactNode {
          return row.order?.identifier ?? row.salesNumber
        },
      },
    },
    {
      key: "orderDate",
      sort: "orderDate",
      attributes: ["orderDate"],
      render: {
        heading: "Order Date",
        render(row: any): React.ReactNode {
          return row.orderDate ? format(new Date(row.orderDate), "dd/MM/yyyy") : "-"
        },
      },
    },
    {
      key: "returnReason",
      sort: "returnReason",
      attributes: ["returnReason"],
      render: {
        heading: "Return Reason",
        render(row: any): React.ReactNode {
          return rmaReturnReasonMessage[row.returnReason as keyof typeof rmaReturnReasonMessage]
        },
      },
    },
    {
      key: "branch",
      sort: "branch",
      attributes: [{ name: "branch", attributes: ["name"] }],
      render: {
        heading: "Branch",
        render(row: any): React.ReactNode {
          return row.branch.name
        },
      },
    },
    {
      key: "assignedTo",
      sort: { by: { path: ["assignedTo", "skeem_email"] }, key: "assignedTo", label: "assignedTo" },
      attributes: [{ name: "assignedTo", attributes: ["name", "skeem_email"] }],
      render: {
        heading: "Assigned To",
        render(row: any): React.ReactNode {
          return row.assignedTo ? (
            <React.Fragment>
              <P blockSpacing={0}>{row.assignedTo.name}</P>
              <P blockSpacing={0} size="small">
                {row.assignedTo.skeem_email}
              </P>
            </React.Fragment>
          ) : (
            ""
          )
        },
      },
    },
    {
      key: "createdAt",
      sort: "created_at",
      attributes: ["created_at"],
      render: {
        heading: "Created",
        render(row: any): React.ReactNode {
          return format(new Date(row.created_at), "dd/MM/yyyy HH:mm")
        },
      },
    },
  ],
})
